export default __webpack_public_path__ + "static/media/screen10.ddedfda9.png";